export default function libraryReducer(file, action) {
  switch (action.type) {
    case "set":
      return action.value;

    default:
      return { ...file, [action.type]: action.value };
  }
}
